export const ALPHABET_WRITING_TEMPLATE_ID = 'alphabet-writing-guide-authoring-v1';
export const ALPHABET_WRITING_PLAYBACK_CONTRACT = 'authoringStrokePlayback';
export const ALPHABET_WRITING_RENDERER_API_VERSION = 'alphabet.authoring_playback_api.v1';
export const ALPHABET_WRITING_RENDER_HOST_API = Object.freeze({
    version: 'alphabet.render_host_api.v1',
    templateId: ALPHABET_WRITING_TEMPLATE_ID,
    playbackContract: ALPHABET_WRITING_PLAYBACK_CONTRACT,
    rendererApiVersion: ALPHABET_WRITING_RENDERER_API_VERSION,
    runtimeVersion: 'alphabet.authoring_runtime.v1',
    renderSpecVersion: 'alphabet.authoring_render_spec.v2',
});
export const ALPHABET_WRITING_RENDER_HOST_SOURCE = '@crabs-ai/alphabet-writing-runtime#render-host-api';
export function parseWritingGuideRenderHostContract(value) {
    if (!isRecord(value)) {
        throw new Error('writing-guide render host contract must be an object');
    }
    if (value.version !== 'alphabet.remotion_render_host.v2' ||
        value.templateId !== ALPHABET_WRITING_TEMPLATE_ID ||
        value.playbackContract !== ALPHABET_WRITING_PLAYBACK_CONTRACT ||
        value.rendererApiVersion !== ALPHABET_WRITING_RENDERER_API_VERSION ||
        value.releaseRegistryVersion !== 'alphabet.approved_render_releases.v1' ||
        !Array.isArray(value.approvedReleases) ||
        !Array.isArray(value.legacyEmbeddedReleases) ||
        !Array.isArray(value.renderHostSourceFiles)) {
        throw new Error('writing-guide render host contract is incompatible');
    }
    return {
        ...value,
        wordLayoutPolicy: parseAlphabetWritingWordLayoutPolicy(value.wordLayoutPolicy),
    };
}
export function parseAlphabetWritingWordLayoutPolicy(value) {
    if (!isRecord(value) ||
        value.version !== 'alphabet.word_layout_policy.v1' ||
        value.allowMultiLine !== false ||
        !isUnitRatio(value.widthRatio) ||
        !isUnitRatio(value.heightRatio)) {
        throw new Error('alphabet word layout policy is incompatible');
    }
    if (value.opticalSpacing !== undefined) {
        parseOpticalSpacing(value.opticalSpacing);
    }
    return value;
}
function parseOpticalSpacing(value) {
    if (!isRecord(value) ||
        !isBoundedRatio(value.defaultSideBearingRatio, 0, 0.25) ||
        !isBoundedRatio(value.minimumGapRatio, 0, 0.25) ||
        !isRecord(value.sideBearings) ||
        !isRecord(value.pairAdjustments)) {
        throw new Error('alphabet optical spacing policy is incompatible');
    }
    for (const [glyphId, sideBearing] of Object.entries(value.sideBearings)) {
        if (!/^[A-Za-z]$/.test(glyphId) ||
            !isRecord(sideBearing) ||
            !isBoundedRatio(sideBearing.left, 0, 0.25) ||
            !isBoundedRatio(sideBearing.right, 0, 0.25)) {
            throw new Error(`alphabet sidebearing is invalid: ${glyphId}`);
        }
    }
    for (const [pair, adjustment] of Object.entries(value.pairAdjustments)) {
        if (!/^[A-Za-z]:[A-Za-z]$/.test(pair) ||
            !isBoundedRatio(adjustment, -0.25, 0.25)) {
            throw new Error(`alphabet kerning pair is invalid: ${pair}`);
        }
    }
    return value;
}
function isUnitRatio(value) {
    return isBoundedRatio(value, Number.EPSILON, 1);
}
function isBoundedRatio(value, minimum, maximum) {
    return (typeof value === 'number' &&
        Number.isFinite(value) &&
        value >= minimum &&
        value <= maximum);
}
function isRecord(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
//# sourceMappingURL=contracts.js.map